var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 302,
    viewBox: "0 0 371 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.356 69.47L127.362 81.5728L77.8066 52.8232L99.5604 40.7205L148.356 69.47Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.356 133.396L127.362 145.502L77.8066 116.752L99.5604 104.65L148.356 133.396Z",
    stroke: "#231F20",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.236 133.396L127.242 145.502L77.6895 116.752L99.44 104.65L148.236 133.396Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.363 81.573V145.502",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7492 40.7205V104.649L77.8301 116.733V52.8041",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.357 69.2571V133.186",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.564 223.164L257.843 261.632L100.361 170.27L169.486 131.799L324.564 223.164Z",
    fill: "#C1282D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.565 93.0904L85.5713 105.193L36.0156 76.4467L57.7662 64.3408L106.565 93.0904Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.565 157.019L85.5713 169.122L36.0156 140.373L57.7662 128.27L106.565 157.019Z",
    stroke: "#231F20",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.445 157.019L85.451 169.122L35.8984 140.373L57.649 128.27L106.445 157.019Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5723 105.193V169.122",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9582 64.3408V128.27L36.0391 140.353V76.4245",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.566 92.8806V156.81",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.214 101.431L261.22 113.537L211.664 84.7875L233.415 72.6848L282.214 101.431Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.214 165.36L261.22 177.466L211.664 148.717L233.415 136.614L282.214 165.36Z",
    stroke: "#231F20",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.093 165.36L261.099 177.466L211.547 148.717L233.297 136.614L282.093 165.36Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.221 113.537V177.466",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.607 72.6848V136.614L211.688 148.697V84.7685",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.215 101.221V165.15",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.268 137.501L326.274 149.607L276.719 120.857L298.469 108.751L347.268 137.501Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.268 201.43L326.274 213.536L276.719 184.786L298.469 172.68L347.268 201.43Z",
    stroke: "#231F20",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.148 201.43L326.154 213.536L276.602 184.786L298.352 172.68L347.148 201.43Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.275 149.607V213.536",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.661 108.751V172.68L276.742 184.764V120.835",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.27 137.291V201.22",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.426 58.1976L186.42 70.3003L235.975 41.5539L214.225 29.448L165.426 58.1976Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.426 122.127L186.42 134.229L235.975 105.483L214.225 93.377L165.426 122.127Z",
    stroke: "#231F20",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.547 122.127L186.541 134.229L236.093 105.483L214.343 93.377L165.547 122.127Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.42 70.3005V134.229",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.033 29.448V93.3769L235.952 105.461V41.5317",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.426 57.9878V121.917",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.225 29.3936L140.218 41.4963L189.771 12.75L168.02 0.644043L119.225 29.3936Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.225 93.3226L140.218 105.425L189.771 76.6757L168.02 64.573L119.225 93.3226Z",
    stroke: "#231F20",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.342 93.3226L140.336 105.425L189.891 76.6757L168.141 64.573L119.342 93.3226Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.832 0.643799V64.5727L189.751 76.6563V12.7275",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.225 93.1093V29.1836L140.218 41.4962V105.425",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.58 225.753L189.574 237.856L239.126 209.11L217.376 197.004L168.58 225.753Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.58 289.682L189.574 301.785L239.126 273.035L217.376 260.933L168.58 289.682Z",
    stroke: "#231F20",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.701 289.682L189.695 301.785L239.247 273.035L217.497 260.933L168.701 289.682Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.574 237.856V301.785",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.188 197.004V260.933L239.107 273.016V209.087",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.58 225.543V289.469",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.361 197.08L148.355 209.186L197.908 180.436L176.157 168.333L127.361 197.08Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.361 261.009L148.355 273.115L197.908 244.365L176.157 232.259L127.361 261.009Z",
    stroke: "#231F20",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.479 261.009L148.475 273.115L198.028 244.365L176.277 232.259L127.479 261.009Z",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.355 209.186V273.114",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.969 168.333V232.259L197.888 244.343V180.417",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.361 196.87V260.799",
    stroke: "white",
    strokeWidth: 0.973052,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5098 170.242V223.327",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3945 165.316V224.049",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3418 174.903V211.046",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2852 177.804V207.173",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4375 174.917V216.707",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7891 175.874V228.962",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7148 180.551V222.341",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2305 179.591V203.876",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6602 182.246V218.389",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6055 184.176V213.543",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5469 184.504V208.789",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1211 185.41V193.881",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0625 177.333V198.273",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0059 175.638V196.578",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1582 184.44V196.298",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9531 175.403V196.343",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8398 172.283V196.028",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7852 166.617V197.678",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7266 163.965V200.674",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8789 179.276V191.137",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6719 168.009V200.199",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5625 162.836V194.46",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5039 157.437V196.969",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4473 164.289V188.033",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5996 173.587V187.035",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3945 163.341V187.086",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2832 160.782V184.523",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2266 166.458V178.319",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.168 159.831V183.575",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3203 167.669V181.117",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.602 158.419V182.163",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.49 155.859V179.601",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.434 154.4V178.144",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.375 157.494V174.223",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.527 162.26V175.708",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.322 156.59V173.32",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.211 154.298V171.027",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.154 154.785V166.881",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.098 150.58V169.675",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.25 158.81V168.286",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.043 151.105V167.835",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.934 148.815V165.545",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.875 149.445V159.538",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.818 145.419V159.761",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.971 153.328V162.804",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.766 147.328V158.55",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.652 145.436V159.478",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.598 145.308V153.258",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.539 143.028V152.492",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.691 149.223V157.176",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.484 142.265V151.725",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.375 139.219V153.328",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.316 139.219V153.328",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.264 136.996V146.148",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.414 143.025V151.013",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.207 134.91V148.495",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.148 132.964V146.548",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.094 132.836V146.421",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.039 133.889V143.489",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.928 133.247V139.457",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.871 128.569V142.125",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.816 123.974V144.914",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.742 127.863V138.554",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.705 122.028V142.968",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.965 131.867V143.725",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.898 196.775V247.539",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.008 191.048V247.215",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.066 202.012V236.575",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.121 203.796V231.878",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.971 201.202V241.167",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.617 202.985V253.749",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.691 205.955V245.92",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.176 205.145V228.367",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.746 208.547V243.109",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.803 210.331V238.413",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.859 211.68V234.903",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.289 209.845V217.944",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.344 203.472V223.496",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.398 202.337V222.361",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25 209.845V221.184",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.457 201.202V221.226",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.566 197.818V220.522",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.625 191.913V221.616",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.676 188.51V223.613",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.527 203.956V215.298",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.734 189.592V220.373",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.846 187.433V217.674",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.902 181.868V219.674",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.957 189.731V212.436",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.809 197.207V210.067",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.014 188.38V211.084",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.125 185.932V208.636",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.182 192.292V203.634",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.234 184.094V206.798",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.086 192.056V204.916",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.805 180.421V203.125",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.918 177.969V200.676",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.973 177.969V200.676",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.027 179.533V195.531",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.879 184.094V196.953",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.648 139.041V169.825",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.758 136.395V166.639",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.812 132.29V170.095",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.871 139.181V161.888",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.719 147.63V160.489",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.926 137.833V160.537",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.039 134.894V157.602",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.092 139.797V151.14",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.148 133.059V155.764",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.996 141.019V153.878",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.719 132.299V155.004",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.832 128.391V151.099",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.885 128.391V151.099",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.941 129.956V145.954",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.789 135.489V148.348",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.086 178.671V194.67",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.195 176.945V192.943",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.254 176.945V188.511",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.309 173.39V191.649",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.158 181.26V190.32",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.363 174.357V190.355",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.477 172.63V188.628",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.531 171.838V181.489",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.586 167.987V181.702",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.438 176.945V186.005",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.645 169.812V180.545",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.754 168.003V181.432",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.812 167.882V175.482",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.865 165.701V174.751",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.717 171.625V179.232",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.922 164.97V174.02",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.033 162.06V175.549",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.09 159.144V172.633",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.145 160.419V169.17",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.996 165.698V173.339",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.201 157.052V170.042",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.254 156.078V169.068",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.312 155.026V168.019",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.369 155.566V164.747",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.48 154.972V160.915",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.535 149.572V162.534",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.59 145.197V165.221",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.438 153.57V164.909",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4375 62.7295L370.861 250.424",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "2.41 2.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.119 131.345L0 225.932",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "2.41 2.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.138 49.6885L191.016 144.275",
    stroke: "#C1282D",
    strokeWidth: 0.728199,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "2.41 2.41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 370.861,
    height: 301.141,
    fill: "white",
    transform: "translate(0 0.644043)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.604c4c0d75d5f6754be442f006fce287.svg";
export { ForwardRef as ReactComponent };